<kendo-dialog *ngIf="aberto" title="Pagamento eletrônico" (close)="feche()" [minWidth]="320" [width]="620">
  <div class="pagamento-eletronico-dialog">
    <div class="alert alert-danger" *ngIf="erro">{{erro}}</div>
    <div class="pagamento-contexto">
      <span class="pagamento-contexto-icone"><i class="fas fa-credit-card"></i></span>
      <div>
        <small>{{pedido?.id ? 'Pedido' : 'Comanda'}}</small>
        <strong>{{pedido?.codigo ? '#' + pedido.codigo : comanda?.descricao || 'Pagamento presencial'}}</strong>
        <span>A cobrança será exibida na máquina selecionada.</span>
      </div>
    </div>
    <div class="pagamento-alerta" *ngIf="possuiTransacaoAtiva">
      <i class="fas fa-spinner fa-spin"></i>
      <span><strong>Pagamento em andamento</strong>Não repita a cobrança enquanto o terminal estiver processando.</span>
    </div>

    <div class="form-group terminal-field">
      <label for="terminalConnectTef">Terminal</label>
      <select id="terminalConnectTef" class="form-control" [(ngModel)]="terminalSelecionado"
              [disabled]="possuiTransacaoAtiva || carregando">
        <option [ngValue]="null">Selecione o terminal</option>
        <option *ngFor="let terminal of terminais" [ngValue]="terminal">
          {{terminal.numeroSerieTerminal || terminal.numeroSerieAutomacao || ('Terminal ' + terminal.id)}}
        </option>
      </select>
      <small class="text-danger" *ngIf="!terminais.length && !carregando">
        Nenhum terminal ConnectTEF ativo e vinculado.
      </small>
    </div>

    <div class="pagamento-item" *ngFor="let pagamento of pagamentosEletronicos"
         [ngClass]="'status-' + (fluxo.obtenhaTransacao(pagamento)?.status || 'waiting').toLowerCase()">
      <div class="pagamento-item-main">
        <span class="pagamento-metodo-icone"><i class="fas fa-credit-card"></i></span>
        <div class="pagamento-descricao">
          <small>Forma de pagamento</small>
          <strong>{{pagamento.formaDePagamento?.nome || pagamento.formaDePagamento?.descricao || 'Pagamento eletrônico'}}</strong>
        </div>
        <div class="pagamento-valor"><small>Valor</small><strong>{{pagamento.valor | currency:'BRL'}}</strong></div>
      </div>
      <div class="pagamento-status-row">
        <span class="pagamento-status"><i class="fas fa-circle"></i>{{textoStatus(pagamento)}}</span>
        <span class="pagamento-fiscal" *ngIf="textoFiscal(pagamento)">{{textoFiscal(pagamento)}}</span>
      </div>
      <p class="text-danger mb-2" *ngIf="fluxo.obtenhaTransacao(pagamento)?.erro">
        {{fluxo.obtenhaTransacao(pagamento)?.erro}}
      </p>
      <button type="button" class="btn btn-primary"
              *ngIf="!fluxo.obtenhaTransacao(pagamento) || podeTentarNovamente(pagamento)"
              [disabled]="!terminalSelecionado || !!cobrandoPagamentoId || possuiTransacaoAtiva"
              (click)="cobre(pagamento)">
        <i class="fas" [ngClass]="cobrandoPagamentoId === pagamento.id ? 'fa-spinner fa-spin' : 'fa-credit-card'"></i>
        {{podeTentarNovamente(pagamento) ? 'Tentar cobrança novamente' : 'Cobrar no terminal'}}
      </button>
    </div>

    <div class="pagamento-vazio" *ngIf="!carregando && !pagamentosEletronicos.length">
      <i class="fas fa-info-circle"></i>
      <span>Não há uma forma de pagamento configurada para o ConnectTEF neste pedido.</span>
    </div>
  </div>

  <kendo-dialog-actions>
    <button type="button" class="btn btn-light" [disabled]="!podeFechar" (click)="feche()">
      {{fluxo.concluido ? 'Concluir' : 'Fechar'}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
